import { ComponentProps, FC } from 'react'
import { FileErrorList, FileList } from './components'
import { useFilePicker } from './hooks'
import { FilePickerPrimitive } from './primitives'
import { Props } from './types'

export const FilePicker: FC<
  Props & Omit<ComponentProps<typeof FilePickerPrimitive.Root>, 'disabled'>
> = ({ filePickerOptions, fileListOptions = { show: true }, children, ...rest }) => {
  const { inputProps, getRootProps, files, fileRejections, handleRemove, handleRejectionRemove } =
    useFilePicker(filePickerOptions, fileListOptions)

  return (
    <>
      <FilePickerPrimitive.Root
        {...getRootProps({ disabled: filePickerOptions.isDisabled, ...rest })}
      >
        <input {...inputProps} />
        {children}
      </FilePickerPrimitive.Root>
      {fileListOptions.show && (
        <FilePickerPrimitive.FileListsRoot
          hasFiles={(!!fileRejections.length || !!files.length) && fileListOptions.show}
        >
          <FileErrorList
            filesRejections={fileRejections}
            onRemove={handleRejectionRemove}
            isDisabled={filePickerOptions.isDisabled}
          />
          <FileList
            variant={fileListOptions.variant || 'default'}
            showFileCount={fileListOptions.showFileCount}
            maxHeight={fileListOptions.maxHeight}
            files={files}
            onRemove={handleRemove}
            isDisabled={filePickerOptions.isDisabled}
          />
        </FilePickerPrimitive.FileListsRoot>
      )}
    </>
  )
}
